import reducer from "./reducer";
export { default as PositionsClassificationSettings } from "./components/index";
export { default as positionsClassificationSettingsReducerName } from "./constants";
export default reducer;
